<template>
  <dialog-layout
    title="Send feedback"
    :fullscreen="fullscreen"
    :navIcon="navIcon"
    :dark="dark"
    @pop-dialog="$emit('pop-dialog')"
  >
    <v-list expand lines="three">
      <v-list-item
        title=""
        prepend-icon="mdi-instagram"
        @click="openUrl('https://instagram.com/austin.foosball.club')"
      >
        <v-list-item-title>Instagram</v-list-item-title>
        <v-list-item-subtitle>To send feedback, DM me on Instagram.</v-list-item-subtitle>
        <v-list-item-subtitle>@austin.foosball.club</v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </dialog-layout>
</template>

<script>
import { DialogLayout } from "vue-app-components";

export default {
  name: "dialog-send-feedback",
  components: {
    DialogLayout
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: true
    },
    navIcon: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$store"],
  methods: {
    openUrl (url) {
      window.open(url, "_blank", "noopener");
    }
  }
};
</script>
